




























import { Component, Vue, Prop } from 'vue-property-decorator';
import FlexButton from '@/components/FlexButton/FlexButton.vue';
import MerchantService from '@/api/MerchantService';
import eventBus from '@/utils/eventBus';
import AlertsService from '@/api/AlertsService';
import alertsENUM from '@/constants/alerts';
import { alert } from '@/store/modules/businessTypes';
import { Provider } from './IProvider';

@Component({
  components: {
    FlexButton
  }
})
export default class OnlineProviderModal extends Vue {
  @Prop({ required: true }) providerToConnect!: Provider;
  @Prop({ required: true }) providerToDisconnect!: Provider;
  @Prop({ default: () => null }) onClose!: () => void;

  service = new MerchantService();
  step = 1;
  loading = false;

  close() {
    eventBus.$emit('closeModal');
    if (this.onClose) this.onClose();
  }

  async connect() {
    this.$showLoaderWithLocker();

    const response = await this.service.connect(
      {
        url: `/merchant-connect/${this.providerToConnect.name}/oauth/connect`,
        method: 'GET'
      },
      this.providerToConnect.params
    );

    if (response) {
      this.$showLoaderWithLocker();
      window.open(response.data.url, '_self');
    } else {
      this.close();
      this.$hideLoader();
      this.$notification('Something went wrong. Try again later.', 'error');
    }
  }
}
